import { FC } from "react";
import styles from "./Form.module.scss";

const FormButton: FC = () => {
    return (
        <button type="submit" className={styles.button}>
            Send a request
        </button>
    );
};

export default FormButton;
